import React, { Component } from 'react';
import { Card, Tab } from 'semantic-ui-react'

import Levers from './levers';
import ScenarioSummary from './scenarioSummary';
import styles from './styles.module.scss';

class SummaryPane extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }

  render() {
    // TODO: include outputs of your choices
    const description =
      <Card.Description>
        {this.props.projection ?
          <ScenarioSummary {...this.props.projection} scenarioKey={this.props.scenarioKey}/> :
          <p>This scenario has not been filled out yet</p>
        }

      </Card.Description>;
    const panes = [
      { menuItem: 'Summary', render: () => description },
      {
        menuItem: 'Levers', render: () =>
          (<React.Fragment>
          {/* <Card.Description>These are some knobs for changing your scenario.</Card.Description> */}
          <Levers scenarioKey={this.props.scenarioKey}/>
          </React.Fragment>
          )
      },
    ];

    // Dual classname to enable global CSS override
    return (
    <Card className={`scenarioCard ${styles.scenarioCard}`}>
      <Card.Content>
        {/* Alternate design */}
        {/* <Label attached='top' size="large">{this.props.title}</Label> */}
        <Card.Header className={styles.header}>{this.props.title}</Card.Header>
        {this.props.hasTabs ? <Tab panes={panes} /> :
        <div style={{'paddingTop': '45px'}}>
          {description}
        </div>
        }
      </Card.Content>
    </Card>
    );
  }
}

class ScenarioCard extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  render() {
    return (
    <SummaryPane
      title={this.props.title}
      scenarioKey={this.props.scenarioKey}
      description={this.props.description}
      hasTabs={this.props.hasTabs}
      projection={this.props.projection} // latest projectionstats
      goals={this.props.goals}
    /> );
  }
}

export default ScenarioCard;



// WEBPACK FOOTER //
// ./src/components/scenarioCard/index.js